export var ProjectionsList;
(function (ProjectionsList) {
    ProjectionsList["Mercator"] = "mercator";
    ProjectionsList["Flat"] = "flat";
})(ProjectionsList || (ProjectionsList = {}));
export var BlobContentType;
(function (BlobContentType) {
    BlobContentType["Text"] = "text/plain";
    BlobContentType["Json"] = "application/json";
    BlobContentType["GeoJson"] = "application/geo+json";
    BlobContentType["Image"] = "image/avif,image/webp,image/apng";
    BlobContentType["Png"] = "image/png";
    BlobContentType["Jpeg"] = "image/jpeg";
    BlobContentType["Svg"] = "image/svg+xml";
})(BlobContentType || (BlobContentType = {}));
export var FetchContentType;
(function (FetchContentType) {
    FetchContentType["Text"] = "text/plain";
    FetchContentType["Json"] = "application/json";
})(FetchContentType || (FetchContentType = {}));
export var IdKeyType;
(function (IdKeyType) {
    IdKeyType["Map"] = "mapId";
    IdKeyType["Atlas"] = "atlasId";
    IdKeyType["Style"] = "styleId";
    IdKeyType["Template"] = "templateId";
    IdKeyType["Feature"] = "featureId";
})(IdKeyType || (IdKeyType = {}));
export var ApiEntity;
(function (ApiEntity) {
    ApiEntity["Map"] = "map";
    ApiEntity["Atlas"] = "atlas";
    ApiEntity["Feature"] = "feature";
    ApiEntity["ViewBox"] = "viewbox";
    ApiEntity["Pin"] = "pin";
    ApiEntity["Centroid"] = "centroid";
    ApiEntity["Shape"] = "shape";
    ApiEntity["Image"] = "image";
    ApiEntity["Svg"] = "svg";
    ApiEntity["Template"] = "template";
    ApiEntity["Style"] = "style";
    ApiEntity["Label"] = "label";
    ApiEntity["Import"] = "import";
    ApiEntity["Clone"] = "clone";
    ApiEntity["Export"] = "export";
    ApiEntity["Stats"] = "stats";
    ApiEntity["Search"] = "search";
    ApiEntity["Count"] = "count";
    ApiEntity["Load"] = "load";
})(ApiEntity || (ApiEntity = {}));
export var ParmasEntity;
(function (ParmasEntity) {
    ParmasEntity["Token"] = "token";
    ParmasEntity["Labels"] = "labels";
    ParmasEntity["DefaultStyle"] = "defaultStyle";
    ParmasEntity["FeatureStyle"] = "featureStyle";
    ParmasEntity["BgColor"] = "bgColor";
    ParmasEntity["Alpha"] = "alpha";
    ParmasEntity["Group"] = "group";
    ParmasEntity["Projection"] = "projection";
    ParmasEntity["Point"] = "point";
    ParmasEntity["Area"] = "area";
    ParmasEntity["Margin"] = "margin";
})(ParmasEntity || (ParmasEntity = {}));
export const EntityId = {
    [ApiEntity.Map]: IdKeyType.Map,
    [ApiEntity.Atlas]: IdKeyType.Atlas,
    [ApiEntity.Style]: IdKeyType.Style,
    [ApiEntity.Template]: IdKeyType.Template,
    [ApiEntity.Feature]: IdKeyType.Feature,
};
export var CrudEntity;
(function (CrudEntity) {
    CrudEntity["Create"] = "create";
    CrudEntity["Read"] = "read";
    CrudEntity["Update"] = "update";
    CrudEntity["Delete"] = "delete";
})(CrudEntity || (CrudEntity = {}));
export var SizeEntity;
(function (SizeEntity) {
    SizeEntity["Width"] = "width";
    SizeEntity["Height"] = "height";
})(SizeEntity || (SizeEntity = {}));
